import axios from '../services/request'

/* 班级列表 */
export const PlanList = (data = {}) => axios.get('api/teach/plan',data);

/* 班级码搜索班级 */
export const getPlan = (data = {}) => axios.get('api/teach/getPlan',data);

/* 加入班级 */
export const pushPlan = (data = {}) => axios.get('api/teach/pushPlan',data);

/* 创建班级 */
export const createPlan = (data = {}) => axios.post('api/teach/createPlan',data);

/* 获取年级 */
export const getYear = (data = {}) => axios.get('api/store/getYear',data);

/* 班级详情 */
export const planDetail = (data = {}) => axios.get('api/teach/planDetail',data);


/* 班级详情-搜索老师 */
export const addTeachSearch = (data = {}) => axios.get('api/teach/addTeachSearch',data);

/* 班级详情-添加老师 */
export const addTeach = (data = {}) => axios.get('api/teach/addTeach',data);


/* 班级详情-移除老师 */
export const removeTeach = (data = {}) => axios.post('api/teach/removeTeach',data);

/* 班级详情-导入学生 */
export const importStudent = (data = {}) => axios.post('api/teach/importStudent',data);

/* 班级详情-删除学生 */
export const removeStudent = (data = {}) => axios.post('api/teach/removeStudent',data);


/* 班级详情-获取学生学习记录 本年 */
export const resettingStudy = (data = {}) => axios.get('api/teach/resettingStudy',data);

/* 班级详情-重置学生学习记录 */
export const delSubmitanswe = (data = {}) => axios.post('api/teach/delSubmitanswe',data);

/* 班级详情-老师退出班级 */
export const qiutPlan = (data = {}) => axios.get('api/teach/qiutPlan',data);

/* 班级详情-手动添加学生 */
export const handCreate = (data = {}) => axios.post('api/teach/handCreate',data);

/* 班级详情-修改班级状态 */
export const pushRidao = (data = {}) => axios.get('api/teach/pushRidao',data);

/* 删除班级 */
export const delPlan = (data = {}) => axios.get('api/teach/delPlan',data);

/* 班级详情 */
export const getDetail = (data = {}) => axios.get('api/teach/getDetail',data);

/* 修改班级信息 */
export const updatePlan = (data = {}) => axios.post('api/teach/updatePlan',data);

/* 恢复班级 */
export const recoveryPlan = (data = {}) => axios.get('api/teach/recoveryPlan',data);

/* 获取分层教学 */
export const getStage = (data = {}) => axios.get('api/teachwork/getStage',data);

/* 获取分层教学学生成绩 */
export const studentStageWork = (data = {}) => axios.get('api/teachwork/studentStageWork',data);

/* 获取分层教学学生做题明细 */
export const stageSubmitList = (data = {}) => axios.get('api/teachwork/stageSubmitList',data);

/* 消息列表 */
export const tidingsList = (data = {}) => axios.get('api/teach/tidingsList',data);

/* 填写备注 */
export const addremark = (data = {}) => axios.post('api/teach/addremark',data);


/* 作业首页顶部统计 */
export const workTopfStatistics = (data = {}) => axios.get('api/teachwork/workTopfStatistics',data);

/* 作业首页-折线图 */
export const workLineChart = (data = {}) => axios.get('api/teachwork/workLineChart',data);


/* 作业首页-作业列表 */
export const workList = (data = {}) => axios.get('api/teachwork/workList',data);


/* 作业详情-折线图 */
export const workDetailLeftLineChart = (data = {}) => axios.get('api/teachwork/workDetailLeftLineChart',data);

/* 作业详情-饼图 */
export const workDetailRightLineChart = (data = {}) => axios.get('api/teachwork/workDetailRightLineChart',data);

/* 获取分层教学班级列表 */
export const getStagePlan = (data = {}) => axios.get('api/teachwork/getStagePlan',data);


/* 获取自主学习班级及班级数据 */
export const selfPlan = (data = {}) => axios.get('api/teachgrades/selfPlan',data);

/* 获取自主学习班级及班级数据-折线图 */
export const selfStudyChart = (data = {}) => axios.get('api/teachgrades/selfStudyChart',data);

/* 获取分层教学详情-折线图 */
export const getStagePlanStageChart = (data = {}) => axios.get('api/teachwork/getStageChart',data);


// 老师班级列表
export const teacherClasses = (data = {}) => axios.get('api/teachcockpit/classes',data);

//班级核心指标
export const teacherKpi = (data = {}) => axios.get('api/teachcockpit/kpi',data);
//学情趋势预警
export const teacherTrends = (data = {}) => axios.get('api/teachcockpit/trends',data);
//等级分布图
export const teacherLevelDistribution = (data = {}) => axios.get('api/teachcockpit/levelDistribution',data);
//题型薄弱点热力图
export const teacherQuestionScores = (data = {}) => axios.get('api/teachcockpit/questionScores',data);
//	四维雷达图
export const teacherRadar = (data = {}) => axios.get('api/teachcockpit/radar',data);
//	班级学情诊断
export const teacherDiagnosis = (data = {}) => axios.get('api/teachcockpit/diagnosis',data);
//题型短板TOP3
export const teacherWeakTop3 = (data = {}) => axios.get('api/teachcockpit/weakTop3',data);

//班级动态
export const teacherStats = (data = {}) => axios.get('api/teachcockpit/stats',data);
//	学生分层列表
export const teacherStudentList = (data = {}) => axios.get('api/teachcockpit/studentList',data);
//	学生详情
export const teacherStudentDetail = (data = {}) => axios.get('api/teachcockpit/studentDetail',data);

export default{
    teacherClasses,
    teacherKpi,
    teacherTrends,
    teacherLevelDistribution,
    teacherQuestionScores,
    teacherRadar,
    teacherDiagnosis,
    teacherWeakTop3,
    teacherStats,
    teacherStudentList,
    teacherStudentDetail,
    PlanList,
    getStagePlanStageChart,
    selfPlan,
    selfStudyChart,
    getStagePlan,
    workDetailLeftLineChart,
    workDetailRightLineChart,
    workTopfStatistics,
    workLineChart,
    workList,
    getPlan,
    pushPlan,
    createPlan,
    getYear,
    planDetail,
    addTeachSearch,
    addTeach,
    removeTeach,
    importStudent,
    removeStudent,
    resettingStudy,
    delSubmitanswe,
    qiutPlan,
    handCreate,
    pushRidao,
    delPlan,
    getDetail,
    updatePlan,
    recoveryPlan,
    getStage,
    studentStageWork,
    stageSubmitList,
    tidingsList,
    addremark
    
}